<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faExclamation, faSpinnerThird } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import FetchIcon from "./FetchIcon"

library.add([faExclamation, faSpinnerThird])

function camelCase (str) {
    let arr = str.split("-")
    let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item.toLowerCase())
    return capital.join("")
}

export default {
    name: "font-awesome-dynamic-icon",
    mixins: [ FetchIcon ],
    props: FontAwesomeIcon.props,
    data () {
        return {
            development: process.env.NODE_ENV === "development",
            devIconsLoaded: library.devIconsLoaded,
            fetched: null,
            fetchedIcon: null,
            iconTypes: {
                fas: "solid",
                far: "regular",
                fal: "light",
                fad: "duotone"
            }
        }
    },
    computed: {
        iconDefinition () {
            if (this.development) {
                return [this.iconPrefix, this.iconName]
            }
            if (this.fetchedIcon) {
                return this.fetchedIcon
            }

            if (library.definitions[this.iconPrefix] && library.definitions[this.iconPrefix][this.iconName]) {
                return {
                    icon: library.definitions[this.iconPrefix][this.iconName],
                    iconName: this.iconName,
                    prefix: this.iconPrefix
                }
            }

            return null
        },
        iconFileName () {
            return camelCase(`fa-${this.iconName}`)
        },
        iconName () {
            return Array.isArray(this.icon) ? this.icon[1] : this.icon
        },
        iconPrefix () {
            return Array.isArray(this.icon) ? this.icon[0] : "far"
        },
        iconType () {
            return this.iconTypes[this.iconPrefix]
        }
    },
    watch: {
        icon () {
            if (!this.iconDefinition && this.fetchIcon) {
                this.fetchIcon()
            }
        }
    },
    async created () {
        if (!this.iconDefinition && this.fetchIcon) {
            this.fetchIcon()
        }
        if (this.development && !library.devIconsLoaded) {
            const libraryImport = (await import("./FontAwesomeImport.js")).default
            const imports = await libraryImport()
            library.add(...imports)
            library.devIconsLoaded = true
            this.devIconsLoaded = true
        }
    },
    render () {
        if (this.development && !this.devIconsLoaded) {
            return
        }

        return this.$createElement(FontAwesomeIcon, {
            props: {
                ...this.$options.propsData,
                icon: this.iconDefinition
            }
        })
    }
}
</script>
